export default{
    // apiUrl:'http://192.168.1.199:94',
    // apiUrl:'https://jobs.hulianzaowu.com',//线上域名
    apiUrl : `${location.origin}` // 自动获取
}
